import styled from 'styled-components';
import { media, space, rems } from '../../ui/helpers';
import fonts from '../../ui/fonts';

const Module = styled.div`
  background: ${({ moduleTheme }) => moduleTheme.background};
  padding: ${space(6)} 0;

  ${media.min('medium')`
    padding: ${space(4)} 0 0;
  `};
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: baseline;
  padding: ${space(4)} 0 ${space(3.5)};

  ${media.min('medium')`
    flex-flow: row wrap;
    justify-content: center;
    margin-top: -${space(4)};
  `};

  ${media.max('medium')`
    align-items: center;
  `};
`;

const Top = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  text-align: center;

  .title,
  h3.title {
    ${fonts.titleLG};
    width: 70%;
    margin-bottom: ${space(2)};
  }

  .subtitle {
    ${fonts.highlightsMD};
    background: none;
    margin-bottom: ${space(5)};
  }

  &:first-child {
    margin-top: 0;
  }

  ${media.min('medium')`
    .title {
      ${fonts.titleMD};
      margin-bottom: ${space(3)};
    }

    h3.title {
      font-size: ${({ isHome }) => (isHome ? `${rems(50)} !important` : `${rems(32)} !important`)};
      margin-bottom: ${space(1)};
    }

    .subtitle {
      ${fonts.highlightsMD};
    }
  `};
`;

const ImageZone = styled.div`
  width: auto;
  height: initial;

  .image {
    margin-top: ${space(6)};
    width: 100%;
    border-radius: 0;
    max-width: 500px;
    margin: auto;
  }

  ${media.min('medium')`

    .image {
        margin: 0 auto;
    }
  `}
`;

const Block = styled.div`
  align-items: center;
  color: ${({ theme }) => theme.hover};
  display: flex;
  flex-direction: column;
  text-align: center;
  position: relative;

  .imageContainer {
    display: flex;
  }

  .personImage {
    width: 15rem;

    ${media.max('medium')`
      width: 13rem;
    `};
  }

  .homeImage {
    width: 9rem;

    ${media.max('medium')`
      width: 7rem;
    `};
  }

  .heartImage {
    width: 10rem;

    ${media.max('medium')`
      width: 8rem;
    `};
  }

  &:not(:last-child) {
    margin-bottom: ${space(2)};
  }

  .image {
    height: ${rems(130)};
    margin-bottom: ${space(1)};
    width: ${rems(130)};
  }

  .big {
    ${fonts.titleLG};
    font-size: ${rems(60)} !important;
    position: relative;
  }

  .prefix {
    ${fonts.bodySM};
    font-size: ${rems(15)} !important;
    position: absolute;
    top: 0.5em;
    left: -2em;
  }

  .small {
    ${fonts.bodyMD};
    font-weight: 300 !important;
    font-size: ${rems(35)} !important;
    color: black !important;
  }

  ${media.min('medium')`
    margin: 0 ${space(6)} ${space(3)} ${space(6)};
    width: calc(33.3333% - ${space(12)});

    .big {
      ${fonts.titleMD};
      font-size: ${rems(80)} !important;
      .prefix {
        ${fonts.titleSM};
        font-size: ${rems(30)} !important;
      }
    }
    .small {
      ${fonts.titleSM};
      font-size: ${rems(30)} !important;
    }
    .image {
      margin-bottom: ${space(2)};
    }
  `};
`;

export { Module, Container, ImageZone, Top, Block };
